import { CompListing } from 'src/WebApiController';

import { CartItem } from './MarketOrdersCartContext';

export type PriceVerificationResult = {
  changedIds: number[];
  unavailableIds: number[];
};

export const compareCartPricesWithFreshListings = (
  cartItems: CartItem[],
  freshCompListings: CompListing[] | null | undefined
): PriceVerificationResult => {
  const freshByListingId = new Map<number, CompListing>();
  for (const comp of freshCompListings ?? []) {
    freshByListingId.set(comp.listingId, comp);
  }

  const changedIds: number[] = [];
  const unavailableIds: number[] = [];

  for (const item of cartItems) {
    const fresh = freshByListingId.get(item.listingId);
    if (!fresh) {
      unavailableIds.push(item.listingId);
      continue;
    }
    // Face-basis exact comparison via the raw pass-through website price, matching
    // the POS backend and SellApi executor gates: any increase above the seen price
    // is surfaced for re-consent; a decrease is a better deal for the buyer and passes.
    const freshOriginalWebsitePrice = fresh.originalWebsitePrice;
    if (
      item.originalWebsitePrice != null &&
      freshOriginalWebsitePrice != null &&
      freshOriginalWebsitePrice > item.originalWebsitePrice
    ) {
      changedIds.push(item.listingId);
    }
  }

  return { changedIds, unavailableIds };
};
